import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'

import {stockEquipmentKeys} from 'src/jobs/stock-equipment/query-keys'

import {adjustStockLevel, getStockSummary, listEquipmentStockSummaries} from './api'
import {rentalAssetKeys} from './query-keys'
import type {StockLevelAdjustmentInput} from './schemas'

export function useEquipmentStockSummaries(options?: {enabled?: boolean}) {
    return useQuery({
        queryKey: rentalAssetKeys.stockSummaries(),
        queryFn: listEquipmentStockSummaries,
        enabled: options?.enabled ?? true,
    })
}

export function useStockSummary(typeId: string, options?: {enabled?: boolean}) {
    return useQuery({
        queryKey: rentalAssetKeys.stockSummary(typeId),
        queryFn: () => getStockSummary(typeId),
        enabled: options?.enabled ?? Boolean(typeId),
    })
}

export function useAdjustStockLevel(typeId: string) {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (input: StockLevelAdjustmentInput) => adjustStockLevel(typeId, input),
        onSuccess: async () => {
            await Promise.all([
                queryClient.invalidateQueries({queryKey: rentalAssetKeys.stockSummary(typeId)}),
                queryClient.invalidateQueries({queryKey: rentalAssetKeys.stockSummaries()}),
                queryClient.invalidateQueries({queryKey: rentalAssetKeys.assets()}),
                // Stock level changes affect per-(job, type) assignable counts on the
                // dispatch board and job details, which read from a separate query cache.
                queryClient.invalidateQueries({queryKey: stockEquipmentKeys.all}),
            ])
        },
    })
}
